import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ILabel } from '../shared/components/map/models/labels.interface';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGraphData } from '../shared/components/map/models/graph-data.interface';
import { MapService } from './map.service';


@Injectable({
  providedIn: 'root'
})
export class LabelsService {

  constructor(private http: HttpClient, private _mapService: MapService) { }

  getGraphData(labelIds: string, data: any = null, bounds?, isBounds: boolean = true): Observable<any> {
    // let url = `${environment.url}/retrieve/data/`;
    let url = `https://data.energy.taskgo.co/api/data/`;
    if (!bounds) bounds = this._mapService.map.getBounds();
    const southwest = bounds.getSouthWest();
    const northeast = bounds.getNorthEast();
    const inBbox = `${northeast.lng},${northeast.lat},${southwest.lng},${southwest.lat}`;

    let params = {
      'labels': labelIds
    }

    if(isBounds){
      params['in_bbox'] = inBbox
    }
    if (data != null) {
      for (let p in data) {
        params[p] = data[p];
      }
    }

    return this.http.get<IGraphData[]>(url, { params });
  }

}
